import $ from 'jquery'

var setOp = {
    SetSelect2() {
        $(`.select2`).attr(`style`, `width: 100% !important`);
    },
    hideLoader() {
        $(`body`).removeClass(`vld-shown`);
        $(`.vld-overlay`).parent().remove();
    },
    getCompanyId(url){
        var array = url.split(`-`);
        return array[array.length - 1];
    },
    getLangCode() {
        var langCode = window.location.pathname.split("/")[1];
        if (langCode == "" || langCode == undefined || langCode == null) {
            return "en";
        }

        return langCode;
    },
    setCoverImage(url){
        $(`#app`).attr(`style`,`background-image: url('https://cdn.turkishexporter.com.tr${url}')`);
    },
    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}

export default setOp